import { useShiftOptionShortcut } from "./useShiftOptionShortcut";

export function usePlanModeShortcut(onToggle: () => void, enabled = true) {
  useShiftOptionShortcut("KeyP", onToggle, { enabled, allowInEditable: true });
}
